import httpClient from "../../../../shared/api/httpClient";

function getLicenseIdOrThrow() {
  try {
    const v = localStorage.getItem("sabi_empresa_id");
    if (!v) throw new Error();
    const n = Number(v);
    if (!Number.isFinite(n) || n <= 0) throw new Error();
    return n;
  } catch {
    throw new Error("No se encontró sabi_empresa_id en localStorage (licencia/empresa requerida).");
  }
}

/**
 * LISTAR ROLES de la licencia activa
 * GET /admin/licenses/:licenseId/roles
 */
export const getRoles = () => {
  const licenseId = getLicenseIdOrThrow();
  return httpClient.get(`/admin/licenses/${licenseId}/roles`);
};